import React from "react";
import { Confirmation } from "containers/components/confirmation";

const LockConfirmation = (props) => (
    <Confirmation
        open={props.setOpen}
        onConfirm={props.onConfirm}
        onClose={props.onClose}
    >
        Are you sure you want to globally <b>{props.isLocked ? "unlock" : "lock"}</b> the
        current month?<br/>This change won't affect users with private locks.
    </Confirmation>
)

export default LockConfirmation;
